const path = {
    scheduledEmails: 'scheduled-emails'
}

const ENV_DEVELOPMENT = 'development'
const ENV_STAGING = 'staging'
const ENV_PRODUCTION = 'production'

module.exports = {
    HTTP_STATUS_200 : 200,
    HTTP_STATUS_201 : 201,
    HTTP_STATUS_400 : 400,
    HTTP_STATUS_401 : 401,
    HTTP_STATUS_403 : 403,
    HTTP_STATUS_404 : 404,
    HTTP_STATUS_500 : 500,

    // hike category or range
    HIKE_CATEGORY_COMMUNICATION : 'communication',
    HIKE_CATEGORY_MANAGER : 'manager',
    HIKE_CATEGORY_SALES : 'sales',
    HIKE_CATEGORY_LIFE_SKILLS : 'life-skills',
    HIKE_CATEGORY_HARD_SKILLS : 'hard-skills',
    HIKE_CATEGORY_DEMO : 'demo',
    HIKE_CATEGORY_PRACTICE : 'practice',
    HIKE_CATEGORY_NO_RATING : 'no_rating',
    
    // automated email error
    SCHEDULED_EMAILS_ERROR: {
        sendHikeScheduledEmails: `${path.scheduledEmails} Error: sendHikeScheduledEmails()`
    },
    
    // automated email rules
    // when participants is uploaded in admin portal ro scans the activation code
    SCHEDULED_EMAIL_RULE_PARTICIPANTS_SIGN_UP : "ParticipantsSignUp",
    // one week before hike.stage[0] start
    SCHEDULED_EMAIL_RULE_ONE_WEEK_BEFORE_HIKE_START : "OneWeekBeforeHikeStart",
    // one day before hike.stage[0]. start
    SCHEDULED_EMAIL_RULE_ONE_DAY_BEFORE_HIKE_START : "OneDayBeforeHikeStart",
    // one hour before every hike.stage[i] start
    SCHEDULED_EMAIL_RULE_ONE_HOUR_BEFORE_EACH_HIKE_STAGE_START: "OneHourBeforeEachHikeStageStart",
    // summit ended and have feedback url
    SCHEDULED_EMAIL_RULE_SUMMIT_END_WITH_FEEDBACK_URL: "SummitEndWithFeedbackURL",

    SCHEDULED_EMAIL_TRIGGER_TIME_OF_ONE_WEEK_IN_MINUTE : 7 * 24 * 60,
    SCHEDULED_EMAIL_TRIGGER_TIME_OF_ONE_DAY_IN_MINUTE : 24 * 60,
    SCHEDULED_EMAIL_TRIGGER_TIME_OF_ONE_HOUR_IN_MINUTE : 60,

    // annotation tools task
    ANNOTATION_TASK_OF_FIVE : 5,
    // annotation tools task - rating type
    ANNOTATION_TASK_TYPE_OF_FIRST_RATING : "FirstRating",
    ANNOTATION_TASK_TYPE_OF_SECOND_RATING : "SecondRating",

    // annotation tools task - status
    ANNOTATION_TASK_STATUS_OPEN : "Open",
    ANNOTATION_TASK_STATUS_IN_PROGRESS : "InProgress",
    ANNOTATION_TASK_STATUS_COMPLETED : "Completed",

    ENV_DEVELOPMENT,
    ENV_STAGING,
    ENV_PRODUCTION,
    AVAILABLE_ENVS : [
        ENV_DEVELOPMENT,
        ENV_STAGING,
        ENV_PRODUCTION    
    ]
}

